/**************************************************************************************************/
/*   File: /src/app/shared/models/local.document.content.ts                                       */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Tuesday February 19th 2019                                                     */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Fri May 03 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
import { environment } from '../../../environments/environment';
/**
 * The local document content
 */
export class LocalDocumentContent {
    /**
     * The content as base 64
     */
    base64Content: string;
    /**
     * True if is centralized document
     */
    centralizedDocument: boolean = environment.centralizedDocument;
    /**
     * The content size
     */
    contentSize: number;
    /**
     * The content type
     */
    contentType: string;
    /**
     * The hashcode
     */
    hashCode: string;
    /**
     * The raw content
     */
    rawContent: Blob;

}